import { useQuery } from 'react-query';
import api from '../utils/api';

const fetchNearbySessions = async (latitude, longitude) => {
  if (!latitude || !longitude) {
    return [];
  }

  const response = await api.get('/api/geofence/nearby', {
    params: {
      latitude,
      longitude,
      radius: 5000 // 5km radius
    }
  });

  return response.data.sessions || [];
};

export const useNearbySessions = (latitude, longitude) => {
  return useQuery(
    ['nearbySessions', latitude, longitude],
    () => fetchNearbySessions(latitude, longitude),
    {
      enabled: !!latitude && !!longitude,
      staleTime: 30000, // 30 seconds
      cacheTime: 5 * 60 * 1000, // 5 minutes
      refetchInterval: 30000, // Refetch every 30 seconds
      retry: 2,
      onError: (error) => {
        console.error('Failed to fetch nearby sessions:', error);
      }
    }
  );
}; 